import React from "react";
import {
  IconCreditCard,
  IconReceipt,
  IconArrowUp,
} from "@tabler/icons-react";

// ===============================================
// BILLING FEATURES
// ===============================================

const BILLING_FEATURES = [
  {
    icon: IconCreditCard,
    name: "Meu Plano",
    desc: "Visualize e gerencie seu plano atual",
  },
  {
    icon: IconReceipt,
    name: "Faturamento",
    desc: "Acompanhe cobranças e histórico financeiro",
  },
  {
    icon: IconArrowUp,
    name: "Upgrades e Recursos",
    desc: "Contrate recursos adicionais ou faça upgrade",
  },
];

// ===============================================
// BILLING STEP COMPONENT
// ===============================================

const BillingStep = () => {
  return (
    <>
      <div className="onb-card__header">
        <h2 className="onb-card__title">Financeiro</h2>
        <p className="onb-card__subtitle">
          Gerencie seu plano e assinaturas
        </p>
      </div>

      <div className="onb-card__body">
        <p className="onb-card__text">
          Nesta área você tem controle total sobre o financeiro da sua conta:
        </p>

        <div className="onb-menu-list">
          {BILLING_FEATURES.map((item, index) => (
            <div key={index} className="onb-menu-item">
              <div className="onb-menu-item__icon">
                <item.icon size={18} />
              </div>
              <div className="onb-menu-item__info">
                <span className="onb-menu-item__name">{item.name}</span>
                <span className="onb-menu-item__desc">{item.desc}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default BillingStep;
